import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useCountUp } from '../../../hooks/useCountUp';

interface StatConfig {
  numericValue: number;
  suffix: string;
  label: string;
  icon: string;
  decimals: number;
  comma?: boolean;
  isCourse?: boolean;
}

const statConfigs: StatConfig[] = [
  { numericValue: 500, suffix: '+', label: '精選全球導師', icon: 'ri-user-star-line', decimals: 0 },
  { numericValue: 6, suffix: '+', label: '精選課程', icon: 'ri-book-open-line', decimals: 0, isCourse: true },
  { numericValue: 95, suffix: '%', label: '就業成功率', icon: 'ri-check-double-line', decimals: 0 },
  { numericValue: 1200, suffix: '+', label: '學員成功案例', icon: 'ri-award-line', decimals: 0, comma: true },
  { numericValue: 4.97, suffix: '', label: '導師平均評分', icon: 'ri-star-fill', decimals: 2 },
];

interface StatItemProps {
  stat: StatConfig;
  isVisible: boolean;
  delay: number;
}

const StatItem = ({ stat, isVisible, delay }: StatItemProps) => {
  const count = useCountUp({
    target: stat.numericValue,
    duration: 1800,
    decimals: stat.decimals,
    isActive: isVisible,
  });

  const displayValue = stat.comma
    ? Math.floor(count).toLocaleString() + stat.suffix
    : stat.decimals > 0
    ? count.toFixed(stat.decimals) + stat.suffix
    : Math.floor(count) + stat.suffix;

  return (
    <div
      className="flex flex-col items-center text-center px-3 sm:px-4 py-3 sm:py-0"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.6s cubic-bezier(0.22,1,0.36,1), transform 0.6s cubic-bezier(0.22,1,0.36,1)',
        transitionDelay: `${delay}ms`,
      }}
    >
      <div className="flex items-center gap-2 mb-1">
        <i className={`${stat.icon} text-base ${stat.isCourse ? 'text-amber-400' : 'text-violet-400'}`} />
        <span className={`font-bold text-xl sm:text-2xl tracking-tight tabular-nums ${stat.isCourse ? 'text-amber-300' : 'text-white'}`}>
          {displayValue}
        </span>
      </div>
      <div className="text-slate-400 text-xs">{stat.label}</div>
    </div>
  );
};

const StatsBar = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.2 });

  return (
    <section ref={ref} className="bg-navy-800 py-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-8 divide-y sm:divide-y-0 sm:divide-x divide-white/10">
          {statConfigs.map((stat, i) => (
            <StatItem key={stat.label} stat={stat} isVisible={isVisible} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
